import React from 'react'
import { Layout } from 'antd';
import moment from 'moment';
const { Footer } = Layout;

export default function MainFooter(props){
    return (
        <Footer 
            style={{ textAlign: 'center' }}>
            ©{moment(new Date()).format('YYYY')} StreSERT Integrated Limited
        </Footer>
    )
}


